import {
  getStaticPathsGenerator,
  getStaticPropsGenerator,
} from '@cinch-nx/landing-feature-articles-sub-hub'

const path = 'announcements/cinch-news'
const resultsPerPage = 10

export const getStaticPaths = getStaticPathsGenerator()
export const getStaticProps = getStaticPropsGenerator({
  subHubPath: path,
  resultsPerPage: resultsPerPage,
  breadCrumbs: [
    { text: 'Home', url: '/' },
    { text: 'Cinch news', url: `/${path}` },
  ],
  generatePageBreadcrumb: true,
})

export { ArticleSubHubFeature as default } from '@cinch-nx/landing-feature-articles-sub-hub'
